const ArrowleftIcon = ({ className = '' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
      <path
        d="M3.3335 8.12994L13.3335 8.12978"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.99984 4.79651L3.13791 7.65844C2.91569 7.88066 2.80458 7.99177 2.80458 8.12984C2.80458 8.26791 2.91569 8.37902 3.13791 8.60125L5.99984 11.4632"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ArrowleftIcon;
